import Cld from 'cloudinary-config';
import { AdvancedImage } from '@cloudinary/react';
import { thumbnail } from '@cloudinary/url-gen/actions/resize';
import { type IOptionalClassName } from 'types/common/Props';

export enum ThumbnailSize {
  Small = 'small',
  Large = 'large',
  None = 'none'
}

interface ICloudinaryImage extends IOptionalClassName {
  imagePublicId: string
  thumbnailSize?: ThumbnailSize
  /** Empty string marks the image as decorative (use when adjacent text already names it). */
  alt?: string
}

const CloudinaryImage = ({ imagePublicId, thumbnailSize = ThumbnailSize.None, className, alt = '' }: ICloudinaryImage) => {
  const cloudinaryImage = Cld.image(imagePublicId);

  switch (thumbnailSize) {
    case 'small':
      cloudinaryImage.resize(thumbnail().width(120).height(120));
      break;
    case 'large':
      cloudinaryImage.resize(thumbnail().width(200).height(200));
      break;
    default:
      break;
  }

  return <AdvancedImage cldImg={cloudinaryImage} className={className} alt={alt}/>;
};

export default CloudinaryImage;
